import React from 'react';

export function useDebugging(configLoading: boolean, iframeLoading: boolean) {
  const [message, setMessage] = React.useState<string>('');

  React.useEffect(() => {
    if (configLoading && !iframeLoading) {
      setMessage('Loading configuration ...');
    }

    if (!configLoading && iframeLoading) {
      setMessage('Loading preview ...');
    }
  }, [configLoading, iframeLoading]);

  return React.useMemo(() => ({ debuggingMessage: message }), [message]);
}
